import React from 'react';
import { Helmet } from "react-helmet";
import Spinner from '../../audi-ui-components/Spinner';
import Layout from '../../components/Layout';
import Location from './components/Location';
import Frame from './components/Frame';
import SearchForm from './components/SearchForm';
import List from './components/List';
import API from '../../functions/api';
import queryString from 'query-string';
import { gtmPageview, gtmPush } from '../../functions/gtm';
import "./locate.scss";
import {
    DEFAULT_THEME,
} from '../../constants';

class LocateTradePart extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            list: [],
            filteredLocations: null,
            selectedLocation: null,
            searchError: null
        }
    }

    componentDidMount() {
        gtmPageview(this.props.location.pathname);
        API.post(
          process.env.RAZZLE_GQLAPI,
          {
            query: /* GraphQL */`query ($filter: LocationDtoFilterInput) {
              locationList(skip: 0, take: 50, where: $filter) {
                items {
                  id
                  type
                  address
                  email
                  latitude
                  longitude
                  mapsURL
                  message
                  name
                  phone
                  postcode
                  state
                  suburb
                  website
                  monday
                  tuesday
                  wednesday
                  thursday
                  friday
                  saturday
                  sunday
                }
              }
            }`,
            variables: {
              filter: {type: {eq: "TradePartCentre"}, status: {eq: true}}
            }
          }
        ).then(response => {
            // console.log(response);
            let items = response.data?.data?.locationList?.items
            this.setState({list: items, loading: false});
        }).catch(err => {
            console.error(err);
            this.setState({loading: false, searchError: "An error has occured"});
        });
    }

    trackEvent = (eventName, data) => {
        // thneed.trigger(eventName, 'locateARepairCentre', data, true);
        gtmPush("locateATradePartsCentre", eventName, "locateATradePartsCentre", data);
    }

    handleSearchSubmit = (data) => {
        const {list} = this.state;
        this.trackEvent('searchSubmit', data);
        var filtered = [];
        if (list && list.length > 0) {
            filtered = list.filter(
                d => d.state === data.state
            );
        }
        if (filtered.length === 1) {
            this.handleSelect(filtered[0]);
            this.setState({searchError: null});
        } else if (filtered.length > 1) {
            this.setState({filteredLocations: filtered, searchError: null});
        } else {
            this.setState({searchError: "There are no locations in that state"})
        }
    }

    getBackButtonText = () => {
        if (this.state.selectedLocation && this.state.filteredLocations) {
            return 'Back to results';
        } else if (this.state.filteredLocations || this.state.selectedLocation) {
            return 'Back to search';
        }
        return null;
    }

    handleBackClick = () => {
        if (this.state.selectedLocation) {
            return this.setState({selectedLocation: null});
        }
        return this.setState({filteredLocations: null});
    }

    getMapLocations = () => {
        if (this.state.selectedLocation) {
            return [this.state.selectedLocation];
        } else if (this.state.filteredLocations) {
            return this.state.filteredLocations;
        }
        return this.state.list;
    }

    handleSelect = (loc) => {
        this.setState({selectedLocation: loc});
        this.trackEvent('selectTradePartsCentre', {tradePartsCentreName: loc.name});
    }

    renderInner = (theme) => {
        const {selectedLocation} = this.state;
        if (selectedLocation) {
            return (
                <Location
                    key={selectedLocation.id}
                    trackEvent={(e) => { this.trackEvent(`tradePartsCentre${e}`, {tradePartsCentreName: selectedLocation.name, location: selectedLocation.type}); }}
                    {...selectedLocation}
                    emailLinkText="Send us an email"
                    websiteLinkText="Visit our website"
                    theme={theme}
                />
            );
        } else if (this.state.filteredLocations) {
            return (
                <List
                    locations={this.state.filteredLocations}
                    onClick={this.handleSelect}
                />
            );
        }
        return (
            <SearchForm
                onSubmit={this.handleSearchSubmit}
                searchBy="state"
                lockSearchBy
                onChangeState={(s) => { this.trackEvent('selectTradePartsCentreState', {state: s}); }}
                error={this.state.searchError}
                theme={theme}
            />
        );
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const theme = query.theme || DEFAULT_THEME;
        const {filteredLocations, selectedLocation, loading} = this.state;

        return (
            <Layout ui={query.ui} embedded={query.embedded} wide={query.wide} theme={theme}>
                <Helmet>
                    <title>Find a Trade Parts Centre | Audi Australia</title>
                </Helmet>

                <main className="audi-forms__page locate">

                    {loading && <div className="spinner-wrapper"><Spinner isContinuous /></div>}

                    <Frame title="Find a Trade Parts Centre"
                        locations={this.getMapLocations()}
                        onClick={this.handleSelect}
                        backButtonText={this.getBackButtonText()}
                        onBackClick={this.handleBackClick}
                    >
                        {this.renderInner(theme)}
                    </Frame>

                </main>
            </Layout>
        );
    }
}

export default LocateTradePart;
